import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Home from '../pages/Home';
import Charges from '../pages/Charges';
import Clients from '../pages/Clients';
import Promotions from '../pages/Promotions';
import Help from '../pages/Help';
import NotFound from '../pages/NotFound';

function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/charges" component={Charges} />
      <Route path="/clients" component={Clients} />
      <Route exact path="/promotions" component={Promotions} />
      <Route exact path="/help" component={Help} />
      <Route component={NotFound} />
    </Switch>
  )
};

export default Routes;
